export default __webpack_public_path__ + "static/media/noImage.12736c51.svg";